import clsx from "clsx";
import type { ProjectProgressBarProps } from "../projectCard.types";
import { 
  getProjectProgress, 
  getPhaseColor, 
  PROJECT_PHASE_CONFIG 
} from "../projectCard.definitions";

export function ProjectProgressBar({ currentPhase }: ProjectProgressBarProps) {
  const progress = getProjectProgress(currentPhase);

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <span className="text-xs font-medium text-raro-gray-700">Progresso</span>
          <span className="text-xs font-bold text-primary-600">{progress}%</span>
        </div>
        <span className="text-xs text-raro-gray-500 bg-raro-gray-50 px-2 py-1 rounded-md">
          {PROJECT_PHASE_CONFIG[currentPhase].label}
        </span>
      </div>
      <div className="w-full bg-raro-gray-100 rounded-full h-2.5 overflow-hidden">
        <div
          className={clsx(
            "h-full rounded-full transition-all duration-500 ease-out",
            getPhaseColor(currentPhase)
          )}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}